import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Person, Skeleton } from 'UI';
import { User } from 'UI/Icons';
import { Icon } from '@haldor/ui';

var ConversationHeader = /*#__PURE__*/function (_Component) {
  _inherits(ConversationHeader, _Component);

  var _super = _createSuper(ConversationHeader);

  function ConversationHeader() {
    var _this;

    _classCallCheck(this, ConversationHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderMeta", function () {
      var conversation = _this.props.conversation;
      return conversation.relationships.map(function (relationship, i) {
        if (relationship.reference != null) {
          if (relationship.referenceType == 'ASSIGNMENT') {
            return /*#__PURE__*/React.createElement("div", {
              key: i
            }, /*#__PURE__*/React.createElement(Link, {
              to: "/assignment/".concat(relationship.referenceID)
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Assignments"
            }), " ", relationship.reference.title));
          }

          if (relationship.referenceType == 'PLAN') {
            return /*#__PURE__*/React.createElement("div", {
              key: i
            }, /*#__PURE__*/React.createElement(Link, {
              to: "/plan/".concat(relationship.referenceID)
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Plans"
            }), " ", relationship.reference.title));
          }

          if (relationship.referenceType == 'SECTION') {
            return /*#__PURE__*/React.createElement("div", {
              key: i
            }, /*#__PURE__*/React.createElement(Link, {
              to: "/groups/".concat(relationship.referenceID)
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "People"
            }), " ", relationship.reference.title));
          }

          if (relationship.referenceType == 'STUDENT') {
            return /*#__PURE__*/React.createElement("div", {
              key: i
            }, /*#__PURE__*/React.createElement(Link, {
              to: "#"
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "People"
            }), " ", relationship.reference.firstName, " ", relationship.reference.lastName));
          }

          if (relationship.referenceType == 'MEETING_INSTANCE') {
            return /*#__PURE__*/React.createElement("div", {
              key: i
            }, /*#__PURE__*/React.createElement(Link, {
              to: "/meeting/".concat(relationship.reference.id, "/instance/").concat(relationship.referenceID)
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Agenda"
            }), " ", relationship.reference.title));
          }
        }

        return null;
      });
    });

    return _this;
  }

  _createClass(ConversationHeader, [{
    key: "render",
    value: function render() {
      var conversation = this.props.conversation;
      return /*#__PURE__*/React.createElement("div", {
        className: "conversation conversation-header"
      }, conversation != null && conversation.relationships.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "meta-container"
      }, this.renderMeta()) : null);
    }
  }]);

  return ConversationHeader;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser
  };
}

export default connect(mapStateToProps)(ConversationHeader);